import './layout.scss';
import Vue from 'vue';
import VueRouter from 'vue-router';
import mhsh from '../../modules/MHSH/mhsh';
import mdtb from '../../modules/MDTB/mdtb';
import mltl from '../../modules/MLTL/mltl';
import VueGallery from '@ui-common/vue-gallery';
import eventBus from '../../common/js/event-bus/event-bus';
import carouselItem from '../../common/components/carousel/item/carousel-item.vue';
import carousel from '../../common/components/carousel/carousel.vue';
import videoPlayer from '../../common/components/video-player/video-player.vue';
import layoutBase from '../layout-base';

Vue.use(VueRouter);
Vue.component('mhsh', mhsh);
Vue.component('mdtb', mdtb);
Vue.component('mltl', mltl);
Vue.component('portal-carousel', carousel);
Vue.component('carousel-item', carouselItem);
Vue.component('vue-gallery', VueGallery);
Vue.component('video-player', videoPlayer);

/* eslint-disable no-new*/
new Vue({
	extends: layoutBase,
	el: '[data-layout-id=AV9HV-app]',
	mounted() {
		eventBus.$on('openOrsi', (orsiFeature) => {
			if (window.ORSI) {
				switch (orsiFeature) {
					case 'chat':
						window.ORSI.chat.openChat();
						break;
					case 'callrequest':
						window.ORSI.callrequest.openCallrequest();
						break;
					case 'writetous':
						window.ORSI.writetous.openWritetous();
						break;
					default:
				}
			}
		});
	}
});
/* eslint-enable*/
